import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { ContractsService } from '@api/contracts.service';
import { environment } from 'environments/environment';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Editor } from 'ngx-editor';
import { debug } from 'console';
import { MatDialog } from '@angular/material/dialog';
import { ModalComponent } from '@shared/components/modal/modal.component';

@Component({
  selector: 'app-contracts-text',
  templateUrl: './contracts-text.component.html',
  styleUrls: ['./contracts-text.component.scss']
})
export class ContractsTextComponent implements OnInit {
  contractId;
  file;
  editor: Editor;
  html = '';
  customerApprove;
  providerApprove
  fileName: string;
  contractDetails;
  contractTextForm: FormGroup;
  constructor(private formBuilder: FormBuilder,
    private contractsService: ContractsService,
    private activatedRoute: ActivatedRoute,
    public router: Router,
    private snackBar: MatSnackBar,
    public dialog: MatDialog
  ) {
    this.contractTextForm = this.formBuilder.group({
      text: [null, []],
    })
  }

  ngOnInit(): void {
    this.editor = new Editor();
    this.contractId = this.activatedRoute.snapshot.params.id
    this.contractsService.getContractById(this.contractId).subscribe((res) => {
      this.contractDetails = res;
    })
    const url = this.router.url;
  }
  postContracts() {
    const data = { contractId: +this.contractId, file: (this.editor?.view?.dom?.innerHTML).toString() }
    this.contractsService.postContracts(data).subscribe((res) => {
      this.router.navigate(
        ['contracts/'],
        { skipLocationChange: false }
      );
    });
  }
  openDialogSendDialog() {
    const dialogRef = this.dialog.open(ModalComponent, {
      width: '400px',
      height: '100px'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.postContracts();
      } else {
        console.log('خیر را انتخاب کردید یا مدال را بستید.');
      }
    });
  }
  openDialog(): void {
    const dialogRef = this.dialog.open(ModalComponent, {
      width: '400px',
      height: '100px'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.postFinalApprove();
      } else {
        console.log('خیر را انتخاب کردید یا مدال را بستید.');
      }
    });
  }

  pdfFileContractDownload(urlFile) {
    window.open(environment.baseUrl + urlFile, '_blank');
  }
  getImageUrl(url: string) {
    if (url) {
      return `${environment.baseUrl}${url}`;
    }
    if (!url) {
      return 'assets/img/no-image.jpg';
    }
  }
  onFileChange(fileChangeEvent) {
    this.file = fileChangeEvent.target.files[0];
    if (this.file) {
      this.fileName = this.file.name;
    }
  }
  acceptCustomer() {
    this.customerApprove = true;
    this.snackBar.open('قرارداد مشتری تایید شد', 'Undo', {
      duration: 1000
    })
  }

  rejectCustomer() {
    this.customerApprove = false;
    this.snackBar.open('قرارداد مشتری رد شد', 'Undo', {
      duration: 1000
    })
  }
  acceptProvider() {
    this.providerApprove = true;
    this.snackBar.open('قرارداد سرویس دهنده تایید شد', 'Undo', {
      duration: 1000
    })
  }
  rejectProvider() {
    this.providerApprove = false;
    this.snackBar.open('قرارداد سرویس دهنده رد شد', 'Undo', {
      duration: 1000
    })
  }
  postFinalApprove() {
    const data = { contractId: +this.contractId, customerApprove: this.customerApprove, providerApprove: this.providerApprove }
    if (this.customerApprove === undefined) {
      delete data?.customerApprove;
    } else if (this.providerApprove === undefined) {
      delete data?.providerApprove;
    }
    this.contractsService.finalApprove(data).subscribe((res: any) => {
      if (res.status === 200 || res.status === 201) {
        this.router.navigate(['contracts/'],);
      }
    })

  }
  ngOnDestroy(): void {
    this.editor.destroy();
  }
}
